export default [
    {
        label: "Documents",
        icon: "icon-folder",
        tableSettings: {
            route: "contractDocuments",
            formType: "sidebarRightSide",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "",
            },
            filterEndpoint: "myContractDocuments",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,
        },
    },
    {
        label: "Contract Items",
        icon: "icon-list",
        tableSettings: {
            route: "contractitems",
            formType: "sidebarRightSide",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "",
            },
            filterEndpoint: "myContractItems",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,
        },
    },
]